import { Alert, Box, Button, Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom'

export default function AwaitingImplementation() {
	const navigate = useNavigate()
	return (
		<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
			<Stack justifyContent="center" gap={2} sx={{ mt: '-300px' }}>
				<Alert severity="error">
					The page you are trying to view will be implemented in a future ticket
				</Alert>
				<Button onClick={() => navigate(-1)} variant="contained">
					Return to Previous Page
				</Button>
			</Stack>
		</Box>
	)
}
